/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAccountList} from '../api'

 export const useQueryGetAccountList = createReactQueryHook('getAccountList', getAccountList)
